import type { AssignedQuizFilters } from '@repo/types/pagination';

export const filterLabels: Record<AssignedQuizFilters, string> = {
  available: 'Dostępne',
  before: 'Dostępne wkrótce',
  past: 'Po Terminie Wykonania',
  completed: 'Ukończone',
  notcompleted: 'Nie ukończone',
};
